// extracted by mini-css-extract-plugin
export default {"tasks":"YN-z","task":"ZN-z","svg":"_N-z","text":"aO-z"};